/**
 * Utility function to merge Tailwind CSS classes
 * Filters out falsy values and joins class names with spaces
 *
 * @param {...(string|boolean|undefined|null)} classes - Class names to merge
 * @returns {string} Merged class string
 *
 * @example
 * cn('base-class', isActive && 'active-class', 'another-class')
 * // Returns: 'base-class active-class another-class' (if isActive is true)
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}
